import React from 'react';

const ΙconSadFace = props => (
    <svg width="72px" height="72px" viewBox="0 0 72 72" {...props}>
      <g
        id="Shop-by-Everything"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Shop-—-By-Collection-—-No-Results-(Desktop)-"
          transform="translate(-79.000000, -334.000000)"
          fill="#F1F1F1"
        >
          <g
            id="no-results_collections"
            transform="translate(79.000000, 334.000000)"
          >
            <path
              d="M36,4.5 C53.32464,4.5 67.5,18.67536 67.5,36 C67.5,53.32464 53.32464,67.5 36,67.5 C18.67536,67.5 4.5,53.32464 4.5,36 C4.5,18.67536 18.67536,4.5 36,4.5 L36,4.5 Z M36,0 C16.08768,0 0,16.08768 0,36 C0,55.91232 16.08768,72 36,72 C55.91232,72 72,55.91232 72,36 C72,16.08768 55.91232,0 36,0 Z"
              id="Fill-1"
            />
            <path
              d="M28,26.5 C28,29.5387456 25.5387456,32 22.5,32 C19.4612544,32 17,29.5387456 17,26.5 C17,23.4612544 19.4612544,21 22.5,21 C25.5387456,21 28,23.4612544 28,26.5"
              id="Fill-2"
            />
            <path
              d="M55,26.5 C55,29.5387456 52.5387456,32 49.5,32 C46.4612544,32 44,29.5387456 44,26.5 C44,23.4612544 46.4612544,21 49.5,21 C52.5387456,21 55,23.4612544 55,26.5"
              id="Fill-3"
            />
            <path
              d="M35.5,41 C42.7827586,41 49.0413793,45.0659341 52,51 L52,51 L48.4366128,50.9997479 C45.8385461,46.8017726 41.0301514,44 35.5,44 C29.9698486,44 25.1614539,46.8017726 22.5633872,50.9997479 L19,51 C21.9586207,45.0659341 28.2172414,41 35.5,41 Z"
              id="Combined-Shape"
              stroke="#F1F1F1"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  );

export default ΙconSadFace;
